import React from 'react'
import styled from 'styled-components'
import TypographyAtom from '../../atoms/typography/typography'

const Container = styled.div`
  display: grid;
  gap: 8px;
`

function FormTitle({ title, description }) {
  return (
    <Container>
      <TypographyAtom type="H4" copy={title} weight="Bold" />
      <TypographyAtom type="P" copy={description} weight="Regular" />
    </Container>
  )
}

export default FormTitle
